import { Stack, Box } from 'braid-design-system';

import type { JobListItemFragment } from 'src/graphql/__generated__';

import { CardMobileView } from '../CardMobileView';
import { JobActions } from '../JobActions/JobActions';
import { JobNumOfCandidates } from '../JobNumOfCandidates/JobNumOfCandidates';
import { JobStatus } from '../JobStatus/JobStatus';
import { JobTitleAndLocation } from '../JobTitleAndLocation/JobTitleAndLocation';
import { UpgradeButton } from '../UpgradeButton/UpgradeButton';

interface Props {
  jobs: JobListItemFragment[];
  loading?: boolean;
}

export const JobListMobile = ({ jobs, loading = false }: Props) => (
  <Stack space="small">
    {jobs.map((job) => {
      const {
        id,
        daysRemaining,
        advertiserJobReference,
        owner,
        locations,
        candidatesCount,
        newCandidatesCount,
        status,
        postType,
        createdDate,
        title,
        canBeUpgraded,
      } = job;
      const location = locations?.[0];
      const createdBy = owner?.fullName;
      return (
        <CardMobileView key={id}>
          <Stack space="large">
            <JobStatus
              jobId={id}
              isDraft={false}
              daysRemaining={daysRemaining ?? 0}
              status={status}
              loading={loading}
            />

            <JobTitleAndLocation
              id={id}
              isDraft={false}
              postType={postType}
              advertiserJobReference={advertiserJobReference}
              createdDate={createdDate}
              createdBy={createdBy}
              title={title}
              location={location}
              loading={loading}
            />

            <JobNumOfCandidates
              jobId={id}
              numberOfCandidates={candidatesCount ?? 0}
              numberOfNewCandidates={newCandidatesCount ?? 0}
              createdDate={createdDate}
              status={status}
              loading={loading}
            />

            {canBeUpgraded && <UpgradeButton job={job} />}

            <Box display="flex" alignItems="flexStart">
              <JobActions job={job} loading={loading} />
            </Box>
          </Stack>
        </CardMobileView>
      );
    })}
  </Stack>
);
